import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import htmlParse from 'react-html-parser';
import AppContext from '../../../contexts/AppContext';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  paper: {
    borderRadius: '10px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    maxWidth: '700px',

    color: 'black',
    outline: 'none',
  },
  locationLink: {
    color: 'white',
  },
  video: {
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  startBtn: {
    marginBottom: theme.spacing(2),
  },
});

class ModalTutorial extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open !== prevProps.open) {
      this.setState({
        open: this.props.open,
      });
    }
  }

  render() {
    const { classes } = this.props;
    const { dictionnary } = this.context;

    return (
      <>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={this.state.open}
          onClose={() => {
            if (this.props.onCloseHandler) {
              this.props.onCloseHandler();
            }
          }}
          closeAfterTransition
          BackdropComponent={Backdrop}
          disableEnforceFocus
          disableAutoFocus
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={this.state.open}>
            <div className={classes.paper}>
              <h2 id="transition-modal-title">Create your Street Gallery </h2>
              <p id="transition-modal-description">
                {htmlParse(dictionnary.get('modal-tutorial'))}
              </p>
              <video className={classes.video} autoPlay loop>
                <source
                  src=" street-gallery/assets/tutorial.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
              <br />
              <Button
                variant="contained"
                color="primary"
                className={classes.startBtn}
                onClick={() => {
                  if (this.props.onCloseHandler) {
                    this.props.onCloseHandler();
                  }
                }}
              >
                {' '}
                &nbsp; {dictionnary.get('common-start-creating')}
              </Button>
            </div>
          </Fade>
        </Modal>
      </>
    );
  }
}

export default withStyles(styles)(ModalTutorial);
